/* Keep Kbite's phone-only restock form copy aligned with its input. */
(() => {
  const watched = new WeakSet();
  function correctCopy(doc) {
    const dialog = doc.querySelector('[role="dialog"]');
    if (!dialog || !dialog.querySelector('input[type="tel"]') ||
        dialog.querySelector('input[type="email"]')) return;
    const message = dialog.querySelector('p.notification-message');
    const privacy = dialog.querySelector('p.privacy-text');
    if (message?.textContent.trim() === 'We will notify you when the product is back in stock') {
      message.textContent = 'Enter your phone number to receive a text when this item is back in stock.';
    }
    if (privacy?.textContent.trim() === 'We respect your privacy and do not share your email with anyone.') {
      privacy.textContent = 'By submitting, you request a back-in-stock text for this item.';
    }
  }
  function watchFrame() {
    const frame = document.getElementById('gw-stock-fulfilled-iframe');
    if (!frame) return;
    try {
      const doc = frame.contentDocument;
      if (!doc?.documentElement) return;
      correctCopy(doc);
      if (!watched.has(doc)) {
        watched.add(doc);
        // Prevent obviously invalid numbers before Kbite's submit handler runs.
        doc.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          if (!button || button.textContent.trim() !== 'Notify Me') return;
          const dialog = button.closest('[role="dialog"]');
          const phone = dialog?.querySelector('input[type="tel"]');
          if (!phone || dialog.querySelector('input[type="email"]')) return;
          const value = phone.value.trim();
          const digits = value.replace(/\D/g, '');
          if (!/^[+\d\s().-]+$/.test(value) || digits.length < 7 || digits.length > 15) {
            event.preventDefault();
            event.stopImmediatePropagation();
            phone.setCustomValidity('Enter a valid phone number, including the area code.');
            phone.reportValidity();
          } else {
            phone.setCustomValidity('');
          }
        }, true);
        doc.addEventListener('input', (event) => {
          if (event.target.matches('input[type="tel"]')) event.target.setCustomValidity('');
        });
        new MutationObserver(() => correctCopy(doc))
          .observe(doc.documentElement, { childList: true, subtree: true });
      }
    } catch (_) { /* Leave cross-origin vendor forms unchanged. */ }
    if (!watched.has(frame)) {
      watched.add(frame);
      frame.addEventListener('load', watchFrame);
    }
  }
  new MutationObserver(watchFrame).observe(document.body, { childList: true, subtree: true });
  watchFrame();
})();
